export const enrollmentConfirmation = {
  title: "Solicitação Enviada com Sucesso!",
  subtitle: "Recebemos a sua solicitação de pré-matrícula. Entraremos em contato em breve para continuar com o processo de admissão.",
  
  nextStepsTitle: "Próximos Passos",
  steps: {
    step1: {
      title: "Revisão da sua solicitação",
      description: "Nossa equipe revisará as informações fornecidas. Entraremos em contato num prazo máximo de 48 horas úteis."
    },
    step2: {
      title: "Visita guiada personalizada",
      description: "Coordenaremos uma visita às nossas instalações onde poderá conhecer a nossa metodologia, equipa educativa e esclarecer todas as suas dúvidas."
    },
    step3: {
      title: "Processo de matrícula",
      description: "Se ambas as partes concordarem e houver vagas disponíveis, procederemos com a formalização da matrícula."
    }
  },
  
  contactTitle: "Precisa Entrar em Contato?",
  contact: {
    phone: "Telefone",
    email: "Email",
    address: "Endereço",
    hours: "Horário",
    hoursValue: "Segunda a Sexta, 8:45h - 14:00h"
  },
  
  scheduleVisit: "Agendar Visita",
  backToHome: "Voltar ao Início",
  
  note: "Se não receber resposta em 48 horas, por favor verifique sua pasta de spam ou entre em contato diretamente conosco."
};